export default function reducerCustomers(state = {}, action) {
  switch (action.type) {
    case 'GET_BRANCH':
      return {
        ...state,
        branch: action.payload.data,
      }
    default:
      return state
  }
}
